import React from 'react'
import styled, { keyframes, css } from 'styled-components'

const slideUpFade = keyframes`
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
`

const Root = styled.div`
  background: ${({ theme }) => theme.colors.surface};
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: ${({ theme }) => theme.radii.lg};
  box-shadow: ${({ theme }) => theme.shadow.md};
  ${({ $noOverflow }) => $noOverflow === false && 'overflow: hidden;'}
  ${({ $noAnimation }) => !$noAnimation && css`animation: ${slideUpFade} 0.5s ease-out;`}
`

const Header = styled.div`
  padding: 14px 16px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border};
  font-weight: 600;
`

const Body = styled.div`
  padding: 16px;
`

const Footer = styled.div`
  padding: 14px 16px;
  border-top: 1px solid ${({ theme }) => theme.colors.border};
  display: flex;
  justify-content: flex-end;
  gap: 8px;
`

export function Card({ title, children, footer, bodyStyle, noAnimation = false, noOverflow, ...props }) {
  return (
    <Root $noAnimation={noAnimation} $noOverflow={noOverflow} {...props}>
      {title && <Header>{title}</Header>}
      <Body style={bodyStyle}>{children}</Body>
      {footer && <Footer>{footer}</Footer>}
    </Root>
  )
}
